import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { cn } from '@avanta/shared/utils/cn';
import { ChevronLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface StepBackButtonProps {
  onClick: () => void;
  className?: string;
}

export const StepBackButton = ({ onClick, className }: StepBackButtonProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.COMMON);

  return (
    <Button
      type="button"
      size="lg"
      icon="back"
      variant="terciary"
      className={cn('w-fit', className)}
      onClick={onClick}
    >
      <ChevronLeft className="size-6" />
      {t('Common.back')}
    </Button>
  );
};
